import { SessionServiceErrorType } from "../../../../interfaces/session-management/enums/error-type";

export class RefreshTokenError extends Error {
	constructor(message) {
		super(message);
		this.name = SessionServiceErrorType.REFRESH_TOKEN_ERROR;

		Object.setPrototypeOf(this, RefreshTokenError.prototype);
	}
}
